import { useContext, useState } from "react";
import { IsAdminUser } from "../../Constants.ts";
import { AuthContext } from "../../context/AuthContext.js";
import AccessTypeDropdown from "../../UIComponents/AccessTypeDropdown.tsx";
import { getADStatusUI } from "../../Utilities/UIUtils.tsx";
import { UserFormRequest } from "../Forms/UserRequest/_core/_models";
import TooltipButton from "../Tools/TooltipButton.tsx";

interface request {
    formData?: UserFormRequest,
    setFormData: (request: UserFormRequest) => void
}

export function UserDetails({ formData, setFormData }: request) {
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const { user: loggedInUser } = useContext(AuthContext);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let prev = formData;
        if (prev) {
            prev[name] = type === 'checkbox' ? checked : value;
            setFormData({ ...prev });
            validate(prev);
        }
    };

    const validate = (fData: UserFormRequest | undefined) => {
        const newErrors: { [key: string]: string } = {};
        if (!fData?.userName?.trim())
            newErrors.userName = "User Name is required";
        if (!fData?.userFirstName?.trim())
            newErrors.userFirstName = "First Name is required";
        if (!fData?.email?.trim()) {
            newErrors.email = "Email is required";
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(fData.email)) {
                newErrors.email = "Please enter a valid email address";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const mandStar = () => (
        <span style={{ color: "red", marginTop: "-3px", float: "right" }}>*</span>
    );
    return (
        <div className="t-users-body">
            <div className="card mb-4">
                <div className="card-header bg-gray">
                    <div className="d-flex flex-row align-items-center justify-content-between">
                        <h4 className="mb-0 fs-5">User Information</h4>
                        <div className="d-flex flex-row align-items-center gap-4">
                            <div className="d-flex flex-row align-items-center gap-1 j_u_status">
                                <label className="form-label fw-bold m-0">AD Status:</label>
                                {(() => {
                                    const adInfo = getADStatusUI(formData?.isAdUser, formData?.accountEnabled);
                                    return (
                                        <div className='d-flex flex-row align-items-center gap-2'>
                                            <TooltipButton title={adInfo.tooltip}>
                                                <span
                                                    className="d-flex align-items-center gap-1"
                                                    style={{
                                                        backgroundColor: adInfo.color,
                                                        color: adInfo.textColor,
                                                        border: `1px solid ${adInfo.border}`,
                                                        fontSize: '11px',
                                                        padding: '3px 8px',
                                                        borderRadius: '4px',
                                                        cursor: 'help',
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                        lineHeight: '1.2'
                                                    }}
                                                >
                                                    {adInfo.icon}
                                                    {adInfo.label}
                                                </span>
                                            </TooltipButton>
                                        </div>
                                    );
                                })()}
                            </div>
                            {/* {
                                typeof formData != 'undefined' && formData.applicationAccess > 0 &&
                                <div className="d-flex flex-row align-items-center gap-1 j_u_appReq">
                                    <label className="form-label fw-bold m-0">Can approve security requests:</label>
                                    <TooltipButton title={formData?.isApprover == 1 ? "Revoke permission to receive and act on security requests." : "Grant permission to receive and act on security requests."}>
                                        <input
                                            type="checkbox"
                                            name="isApprover"
                                            id="isApprover"
                                            disabled={!IsAdminUser(loggedInUser)}
                                            checked={formData?.isApprover == 1}
                                            onChange={(e) => {
                                                if (formData) {
                                                    let prev = formData;
                                                    prev.isApprover = e.target.checked ? 1 : 0;
                                                    setFormData({ ...prev });
                                                }
                                            }}
                                            className="form-check-input m-0"
                                        />
                                    </TooltipButton>
                                </div>
                            } */}
                            <div className="d-flex flex-row align-items-center gap-1 j_u_status">
                                <label className="form-label fw-bold m-0">Warehouse Distribution Access:</label>
                                <div className="form-check form-switch  j_u_ad_tgl">
                                    <input
                                        type="checkbox"
                                        role="switch"
                                        name="hasWHDIS"
                                        id="hasWHDIS"
                                        checked={formData?.hasWHDIS}
                                        onChange={(e) => {
                                            if (formData) {
                                                let prev = formData;
                                                prev.hasWHDIS = e.target.checked;
                                                setErrors({});
                                                setFormData({ ...prev });
                                            }
                                        }}
                                        className="form-check-input form-switch"
                                    />
                                </div>
                            </div>
                            {/* <div className="d-flex flex-row align-items-center gap-1 j_u_status">
                                <label className="form-label fw-bold m-0">User Status:</label>
                                <div className={IsAdminUser(loggedInUser) ? "d-flex align-items-center gap-0 bg-theme-card border rounded-2 ps-2" : "d-flex align-items-center gap-0 border rounded-2 ps-2"}>
                                    <UserStatusIcon {...{ status: formData?.status || "", size: 20 }} />
                                    <select
                                        className="form-select border-0 box-0"
                                        style={{ width: "90px", boxShadow: "none" }}
                                        name="status"
                                        value={formData?.status}
                                        onChange={handleChange}
                                        disabled={!IsAdminUser(loggedInUser)}
                                    >
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                        <option value="pending">Pending</option>
                                        <option value="rejected">Rejected</option>
                                    </select>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-10 mb-3 j_u_uNam">
                            <div className="d-flex flex-row align-items-center justify-content-between w-100">
                                <label className="form-label fw-bold">User Name:{mandStar()}</label>
                                {/* <div className="form-check form-switch  j_u_ad_tgl">
                                    <input
                                        type="checkbox"
                                        role="switch"
                                        name="isAdUser"
                                        id="isAdUser"
                                        checked={formData?.isAdUser == 1}
                                        onChange={(e) => {
                                            if (formData) {
                                                let prev = formData;
                                                prev.userName = "";
                                                prev.email = "";
                                                prev.userExt = "";
                                                prev.userFirstName = "";
                                                prev.userLastName = "";
                                                prev.isAdUser = e.target.checked ? 1 : 0;
                                                setErrors({});
                                                setFormData({ ...prev });
                                            }
                                        }}
                                        className="form-check-input form-switch"
                                    />
                                    <label className="form-check-label" htmlFor="isAdUser">AD User</label>
                                </div> */}
                            </div>
                            <input
                                type="text"
                                name="userName"
                                value={formData?.userName}
                                onChange={handleChange}
                                disabled
                                className={`form-control ${errors.userName ? "is-invalid" : ""}`}
                            />
                        </div>
                        <div className="col-md-2 mb-3  j_u_ap_acc">
                            <label className="form-label fw-bold">Application Access:</label>
                            <AccessTypeDropdown
                                disabled={!IsAdminUser(loggedInUser)}
                                initVal={formData?.applicationAccess || 0}
                                onChange={(v) => {
                                    let prev = formData;
                                    if (prev) {
                                        if (v == 0)
                                            prev.isApprover = 0;
                                        prev.applicationAccess = v;
                                        setFormData({ ...prev });
                                    }
                                }}
                            />
                        </div>

                        <div className="col-md-6 mb-3 j_u_fname">
                            <label className="form-label fw-bold">First Name:{mandStar()}</label>
                            <input
                                type="text"
                                disabled
                                name="userFirstName"
                                value={formData?.userFirstName}
                                onChange={handleChange}
                                className={`form-control ${errors.userFirstName ? "is-invalid" : ""}`}
                            />
                            {errors.userFirstName && <div className="invalid-feedback">{errors.userFirstName}</div>}
                        </div>
                        <div className="col-md-6 mb-3 j_u_lname">
                            <label className="form-label fw-bold j_u_lname">Last Name:</label>
                            <input type="text" name="hidden-dummy" style={{ display: 'none' }} />
                            <input
                                type="text"
                                name="userLastName"
                                disabled
                                autoComplete="new-search"
                                value={formData?.userLastName}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                        <div className="col-md-6 mb-3 j_u_mail">
                            <label className="form-label fw-bold">Email:{mandStar()}</label>
                            <input
                                type="text"
                                name="email"
                                disabled
                                value={formData?.email}
                                onChange={handleChange}
                                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                        </div>
                        <div className="col-md-6 mb-3 j_u_mngr">
                            <label className="form-label fw-bold">Manager Name:</label>
                            <input
                                type="text"
                                name="managerName"
                                disabled
                                value={formData?.managerName}
                                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            />
                            {/* <UsersDD disabled={true} placeholder="--" initSelect={(typeof formData != 'undefined') ? formData.managerUserID?.toString() : ""}
                                applicationAccess={[UserType.Admin, UserType.Manager]} updateUser={(u) => {
                                    let prev = formData;
                                    if (prev) {
                                        prev.managerUserID = u.userID
                                        setFormData({ ...prev });
                                        validate(prev);
                                    }
                                }} /> */}
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Job Title:</label>
                            <input type="text" disabled value={formData?.jobTitle || ""} className="form-control" />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Department:</label>
                            <input type="text" disabled value={formData?.department || ""} className="form-control" />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Company Name:</label>
                            <input type="text" disabled value={formData?.companyName || ""} className="form-control" />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Employee Type:</label>
                            <input type="text" disabled value={formData?.employeeType || ""} className="form-control" />
                        </div>

                        {/* Location Details */}
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">City:</label>
                            <input type="text" disabled value={formData?.city || ""} className="form-control" />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Country:</label>
                            <input type="text" disabled value={formData?.country || ""} className="form-control" />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Office Location:</label>
                            <input type="text" disabled value={formData?.officeLocation || ""} className="form-control" />
                        </div>

                        {/* Contact & Additional System Details */}
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Mobile Phone:</label>
                            <input type="text" disabled value={formData?.mobilePhone || ""} className="form-control" />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Business Phones:</label>
                            <input type="text" disabled value={formData?.businessPhones || ""} className="form-control" />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Account Enabled:</label>
                            <input
                                type="text"
                                disabled
                                value={formData?.accountEnabled !== undefined ? (formData.accountEnabled ? "Yes" : "No") : ""}
                                className="form-control"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Account Holder Email:</label>
                            <input
                                type="text"
                                name="accountHolderEmail"
                                onChange={handleChange}
                                disabled={!IsAdminUser(loggedInUser)}
                                value={formData?.accountHolderEmail}
                                className="form-control"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Distribution User Email:</label>
                            <input
                                type="text"
                                name="distributionUserEmail"
                                onChange={handleChange}
                                disabled={!IsAdminUser(loggedInUser)}
                                value={formData?.distributionUserEmail}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserDetails;